export * from './MorseBeepManager';
export { default } from './MorseBeepManager';
